import { MediaMatcher } from '@angular/cdk/layout';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { ViewReasonComponent } from 'src/app/admin/components/view-reason/view-reason.component';
import { AppComponent } from 'src/app/app.component';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
declare let $: any;

@Component({
  selector: 'app-knowledge-exp-page',
  templateUrl: './knowledge-exp-page.component.html',
  styleUrls: ['./knowledge-exp-page.component.css'],
})
export class KnowledgeExpPageComponent implements OnInit {
  settingsForm: FormGroup;
  private saveApi = environment.url + environment.knowledgeSave;
  private getApi = environment.url + environment.knowledgeGet;
  /**
   * Constructor to initialize the KnowledgeExpPageComponent.
   * Sets up the form group with various form controls for different questions.
   * Initializes the media query listener.
   */
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog,
    private appCom: AppComponent,
    private http: HttpClient
  ) {
    // Initialize the settings form with form controls for each question
    this.settingsForm = this.fb.group({
      // Question 001: Mentor Network
      mentorNetworkIncCentre: [''],
      mentorNetworkDocuments: new FormArray([]),
      mentorNetworkMentoringHours: [''],
      mentorNetworkNoOfMentors: [''],
      mentorNetworkImagefile: [''],
      mentorNetworkStatus: [0],

      // Question 002: Expertise Assistance
      expertiseAssistanceIncCentre: [''],
      expertiseAssistanceDocuments: new FormArray([]),
      expertiseAssistanceNoOfProgrammes: [''],
      expertiseAssistanceImagefile: [''],
      expertiseAssistanceStatus: [0],

      // Question 003: Guidance Registration
      guidanceRegistrationIncCentre: [''],
      guidanceRegistrationDocuments: new FormArray([]),
      guidanceRegistrationUrlIcWebsite: [''],
      guidanceRegistrationImagefile: [''],
      guidanceRegistrationStatus: [0],

      // Question 004: Filed and Granted
      filedGrantedIncCentre: [''],
      filedGrantedDocuments: new FormArray([]),
      filedGrantedNoOfIPFiled: [''],
      filedGrantedImagefile: [''],
      filedGrantedStatus: [0],

      // Question 005: DPIIT Registration
      dpiitregistrationIncCentre: [''],
      dpiitregistrationDocuments: new FormArray([]),
      dpiitregistrationNoOfProgrammes: [''],
      dpiitregistrationImagefile: [''],
      dpiitregistrationStatus: [0],

      // Question 006: DPIIT Registered Startups
      dpiitregistrationstartupsIncCentre: [''],
      dpiitregistrationstartupsDocuments: new FormArray([]),
      dpiitregistrationstartupsImagefile: [''],
      dpiitregistrationstartupsStatus: [0],
      incubateesdpiitrecogcount: [''],

      // Question 007: Total Physical Incubation
      totalPhysicalIncCentre: [''],
      totalPhysicalDocuments: new FormArray([]),
      totalPhysicalImagefile: [''],
      noofPhysical: [''],
      noofVirtual: [''],
      totalPhysicalStatus: [0],

      // Question 008: Training Workshops
      trainingworkshopCentre: [''],
      trainingworkshopDocuments: new FormArray([]),
      trainingworkshopNoofprograms: [''],
      trainingworkshopImagefile: [''],
      trainingworkshopStatus: [0],

      // Question 009: Newsletters
      newlettersCentre: [''],
      newlettersDocuments: new FormArray([]),
      newlettersUrlIcWebsite: [''],
      newlettersImagefile: [''],
      newlettersStatus: [0],

      // Question 010: Mentor Investor Programs
      mentorinvestorCentre: [''],
      mentorinvestorDocuments: new FormArray([]),
      mentorinvestorNoofprograms: [''],
      mentorinvestorImagefile: [''],
      mentorinvestorStatus: [0],

      // Question 011: Pre-incubation Cohort
      preincubationcohortCentre: [''],
      preincubationcohortDocuments: new FormArray([]),
      preincubationcohortNoofprograms: [''],
      preincubationcohortImagefile: [''],
      preincubationcohortStatus: [0],

      // Question 012: Placement Drives
      placementdriveCentre: [''],
      placementdriveDocuments: new FormArray([]),
      placementdriveNoofdrives: [''],
      placementdriveImagefile: [''],
      placementdriveStatus: [0],
    });

    // Initialize media query for responsive design
    this.mobileQuery = media.matchMedia('(max-width: 992px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
  }
  get setting() {
    return this.settingsForm.controls;
  }
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  ngAfterViewInit(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  /**
   * This method is called when the component is initialized.
   * It calls the `getPush` method to get the push notification permission,
   * It calls the `getDataApi` method to get the data from the API,
   * It calls the `guidelineDatas` method to get the guideline data from the API.
   */
  ngOnInit(): void {
    this.getPush();
    this.getDataApi();
    this.guidelineDatas();
  }
  getValue: any = {};
  getDataApi() {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('userId'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.getValue = data;
        if (data.responseStatus != 'Failed') {
          this.settingsForm.patchValue(data);
          if (data.mentorNetworkIncCentre == 'Yes') {
            this.showOptionsone('Yes', '.upload0', 0, '.set-succ0');
          }
          if (data.expertiseAssistanceIncCentre == 'Yes') {
            this.showOptionstwo('Yes', '.upload1', 1, '.set-succ1');
          }
          if (data.guidanceRegistrationIncCentre == 'Yes') {
            this.showOptionsthree('Yes', '.upload2', 2, '.set-succ2');
          }
          if (data.filedGrantedIncCentre == 'Yes') {
            this.showOptionsfour('Yes', '.upload3', 3, '.set-succ3');
          }
          if (data.dpiitregistrationIncCentre == 'Yes') {
            this.showOptionsfive('Yes', '.upload4', 4, '.set-succ4');
          }
          if (data.dpiitregistrationstartupsIncCentre == 'Yes') {
            this.showOptionssix('Yes', '.upload5', 5, '.set-succ5');
          }
          if (data.totalPhysicalIncCentre == 'Yes') {
            this.showOptionsseven('Yes', '.upload6', 6, '.set-succ6');
          }
          if (data.trainingworkshopCentre == 'Yes') {
            this.showOptions8('Yes', '.upload7', 7, '.set-succ7');
          }
          if (data.newlettersCentre == 'Yes') {
            this.showOptions9('Yes', '.upload8', 8, '.set-succ8');
          }
          if (data.mentorinvestorCentre == 'Yes') {
            this.showOptions10('Yes', '.upload9', 9, '.set-succ9');
          }
          if (data.preincubationcohortCentre == 'Yes') {
            this.showOptions11('Yes', '.upload10', 10, '.set-succ10');
          }
          if (data.placementdriveCentre == 'Yes') {
            this.showOptions12('Yes', '.upload11', 11, '.set-succ11');
          }
          let getform = this.settingsForm.value;
          if (
            data.mentorNetworkDocuments != '' &&
            data.mentorNetworkDocuments != undefined
          ) {
            this.documentValues[0] = data.mentorNetworkDocuments;
            getform.mentorNetworkImagefile =
              data.mentorNetworkDocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ0').addClass('success');
              $('.upload-wrapper.upload0').addClass('d-none');
              $('.upload-wrapper.upload0').removeClass('success');
              $('.remove-wrapper.upload0').addClass('d-flex');
              $('.remove-wrapper.upload0').addClass('active');
            }, 5000);
          }
          if (
            data.expertiseAssistanceDocuments != '' &&
            data.expertiseAssistanceDocuments != undefined
          ) {
            this.documentValues[1] = data.expertiseAssistanceDocuments;
            getform.expertiseAssistanceImagefile =
              data.expertiseAssistanceDocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ1').addClass('success');
              $('.upload-wrapper.upload1').addClass('d-none');
              $('.upload-wrapper.upload1').removeClass('success');
              $('.remove-wrapper.upload1').addClass('d-flex');
              $('.remove-wrapper.upload1').addClass('active');
            }, 5000);
          }
          if (
            data.guidanceRegistrationDocuments != '' &&
            data.guidanceRegistrationDocuments != undefined
          ) {
            this.documentValues[2] = data.guidanceRegistrationDocuments;
            getform.guidanceRegistrationImagefile =
              data.guidanceRegistrationDocuments[0].documentFile;

            setTimeout(function () {
              $('.set-succ2').addClass('success');
              $('.upload-wrapper.upload2').addClass('d-none');
              $('.upload-wrapper.upload2').removeClass('success');
              $('.remove-wrapper.upload2').addClass('d-flex');
              $('.remove-wrapper.upload2').addClass('active');
            }, 5000);
          }
          if (
            data.filedGrantedDocuments != '' &&
            data.filedGrantedDocuments != undefined
          ) {
            this.documentValues[3] = data.filedGrantedDocuments;
            getform.filedGrantedImagefile =
              data.filedGrantedDocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ3').addClass('success');
              $('.upload-wrapper.upload3').addClass('d-none');
              $('.upload-wrapper.upload3').removeClass('success');
              $('.remove-wrapper.upload3').addClass('d-flex');
              $('.remove-wrapper.upload3').addClass('active');
            }, 5000);
          }
          if (
            data.dpiitregistrationDocuments != '' &&
            data.dpiitregistrationDocuments != undefined
          ) {
            this.documentValues[4] = data.dpiitregistrationDocuments;
            getform.dpiitregistrationImagefile =
              data.dpiitregistrationDocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ4').addClass('success');
              $('.upload-wrapper.upload4').addClass('d-none');
              $('.upload-wrapper.upload4').removeClass('success');
              $('.remove-wrapper.upload4').addClass('d-flex');
              $('.remove-wrapper.upload4').addClass('active');
            }, 5000);
          }
          if (
            data.dpiitregistrationstartupsDocuments != '' &&
            data.dpiitregistrationstartupsDocuments != undefined
          ) {
            this.documentValues[5] = data.dpiitregistrationstartupsDocuments;
            getform.dpiitregistrationstartupsImagefile =
              data.dpiitregistrationstartupsDocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ5').addClass('success');
              $('.upload-wrapper.upload5').addClass('d-none');
              $('.upload-wrapper.upload5').removeClass('success');
              $('.remove-wrapper.upload5').addClass('d-flex');
              $('.remove-wrapper.upload5').addClass('active');
            }, 5000);
          }
          if (
            data.totalPhysicalDocuments != '' &&
            data.totalPhysicalDocuments != undefined
          ) {
            this.documentValues[6] = data.totalPhysicalDocuments;
            getform.totalPhysicalImagefile =
              data.totalPhysicalDocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ6').addClass('success');
              $('.upload-wrapper.upload6').addClass('d-none');
              $('.upload-wrapper.upload6').removeClass('success');
              $('.remove-wrapper.upload6').addClass('d-flex');
              $('.remove-wrapper.upload6').addClass('active');
            }, 5000);
          }
          if (
            data.trainingworkshopDocuments != '' &&
            data.trainingworkshopDocuments != undefined
          ) {
            this.documentValues[7] = data.trainingworkshopDocuments;
            getform.trainingworkshopImagefile =
              data.trainingworkshopDocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ7').addClass('success');
              $('.upload-wrapper.upload7').addClass('d-none');
              $('.upload-wrapper.upload7').removeClass('success');
              $('.remove-wrapper.upload7').addClass('d-flex');
              $('.remove-wrapper.upload7').addClass('active');
            }, 5000);
          }
          if (
            data.newlettersDocuments != '' &&
            data.newlettersDocuments != undefined
          ) {
            this.documentValues[8] = data.newlettersDocuments;
            getform.newlettersImagefile =
              data.newlettersDocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ8').addClass('success');
              $('.upload-wrapper.upload8').addClass('d-none');
              $('.upload-wrapper.upload8').removeClass('success');
              $('.remove-wrapper.upload8').addClass('d-flex');
              $('.remove-wrapper.upload8').addClass('active');
            }, 5000);
          }
          if (
            data.mentorinvestorDocuments != '' &&
            data.mentorinvestorDocuments != undefined
          ) {
            this.documentValues[9] = data.mentorinvestorDocuments;
            getform.mentorinvestorImagefile =
              data.mentorinvestorDocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ9').addClass('success');
              $('.upload-wrapper.upload9').addClass('d-none');
              $('.upload-wrapper.upload9').removeClass('success');
              $('.remove-wrapper.upload9').addClass('d-flex');
              $('.remove-wrapper.upload9').addClass('active');
            }, 5000);
          }
          if (
            data.preincubationcohortDocuments != '' &&
            data.preincubationcohortDocuments != undefined
          ) {
            this.documentValues[10] = data.preincubationcohortDocuments;
            getform.preincubationcohortImagefile =
              data.preincubationcohortDocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ10').addClass('success');
              $('.upload-wrapper.upload10').addClass('d-none');
              $('.upload-wrapper.upload10').removeClass('success');
              $('.remove-wrapper.upload10').addClass('d-flex');
              $('.remove-wrapper.upload10').addClass('active');
            }, 5000);
          }
          if (
            data.placementdriveDocuments != '' &&
            data.placementdriveDocuments != undefined
          ) {
            this.documentValues[11] = data.placementdriveDocuments;
            getform.placementdriveImagefile =
              data.placementdriveDocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ11').addClass('success');
              $('.upload-wrapper.upload11').addClass('d-none');
              $('.upload-wrapper.upload11').removeClass('success');
              $('.remove-wrapper.upload11').addClass('d-flex');
              $('.remove-wrapper.upload11').addClass('active');
            }, 5000);
          }
          this.settingsForm.patchValue(getform);
        }
      });
  }
  pickColor(val) {
    return this.getdata.questionStatus(val);
  }
  pickWidth(val) {
    return this.getdata.statusWidth(val);
  }
  innerValue(val) {
    return this.getdata.StatusName(val);
  }
  /**
   * Opens a dialog to display the reason for the given status.
   * @param status - The status object or value to show the reason for.
   */
  viewReasonBtn(status: any): void {
    const dialogRef = this.dialog.open(ViewReasonComponent, {
      width: '390px',
      data: { _status: status },
    });

    // Handle the dialog's closed event
    dialogRef.afterClosed().subscribe((result) => {
      // No action needed after the dialog is closed.
    });
  }
  /**
   * Updates the form control with a specified value.
   *
   * @param event - The event that triggered this function (not used).
   * @param key - The name of the form control to update.
   * @param value - The value to set the form control to.
   */
  setStatus(event: any, key: string, value: any): void {
    // Set the specified form control to the given value
    this.settingsForm.controls[key].setValue(value);
  }
  /**
   * Populates the `documentValues` array with 14 new document request objects,
   * each containing empty `documentName` and `documentFile` fields.
   */
  getPush() {
    // Loop 14 times to create 14 new document request objects
    for (let i = 0; i < 14; i++) {
      // Create a new document request object with empty fields
      const req = [
        {
          documentName: '',
          documentFile: '',
        },
      ];
      // Add the object to the array
      this.documentValues.push(req);
    }
  }
  selecetdFile: any = [];
  url: any;
  ImageValue: any = '';
  ImageType: any;
  documentValues = [];
  /**
   * Handles the file upload event.
   *
   * @param event - The file input event.
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference used for accessing the form control.
   */
  fileUpload(event, val, i, set) {
    this.selecetdFile = event.target.files[0];
    if (event.target.files && this.selecetdFile) {
      let reader = new FileReader();
      let imagetype = this.selecetdFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];

      if (
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png' ||
        img_crt_type == 'pdf'
      ) {
        reader.readAsDataURL(this.selecetdFile);
        reader.onload = () => {
          this.url = reader.result;
          // Split the URL to get the file data
          let spl = this.url.split(',');
          let val = this.documentValues[i];
          val[0].documentFile = spl[1];
          val[0].documentName = this.selecetdFile.name;
          this.documentValues[i] = val;
          // Update the form control based on the index
          switch (i) {
            case 0:
              this.settingsForm.controls['mentorNetworkStatus'].setValue(7);
              this.settingsForm.controls['mentorNetworkImagefile'].setValue(
                this.selecetdFile.name
              );
              break;
            case 1:
              this.settingsForm.controls['expertiseAssistanceStatus'].setValue(
                7
              );
              this.settingsForm.controls[
                'expertiseAssistanceImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            case 2:
              this.settingsForm.controls['guidanceRegistrationStatus'].setValue(
                7
              );
              this.settingsForm.controls[
                'guidanceRegistrationImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            case 3:
              this.settingsForm.controls['filedGrantedStatus'].setValue(7);
              this.settingsForm.controls['filedGrantedImagefile'].setValue(
                this.selecetdFile.name
              );
              break;
            case 4:
              this.settingsForm.controls['dpiitregistrationStatus'].setValue(7);
              this.settingsForm.controls['dpiitregistrationImagefile'].setValue(
                this.selecetdFile.name
              );
              break;
            case 5:
              this.settingsForm.controls[
                'dpiitregistrationstartupsStatus'
              ].setValue(7);
              this.settingsForm.controls[
                'dpiitregistrationstartupsImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            case 6:
              this.settingsForm.controls['totalPhysicalStatus'].setValue(7);
              this.settingsForm.controls['totalPhysicalImagefile'].setValue(
                this.selecetdFile.name
              );
              break;
            case 7:
              this.settingsForm.controls['trainingworkshopStatus'].setValue(7);
              this.settingsForm.controls['trainingworkshopImagefile'].setValue(
                this.selecetdFile.name
              );
              break;
            case 8:
              this.settingsForm.controls['newlettersStatus'].setValue(7);
              this.settingsForm.controls['newlettersImagefile'].setValue(
                this.selecetdFile.name
              );
              break;
            case 9:
              this.settingsForm.controls['mentorinvestorStatus'].setValue(7);
              this.settingsForm.controls['mentorinvestorImagefile'].setValue(
                this.selecetdFile.name
              );
              break;
            case 10:
              this.settingsForm.controls['preincubationcohortStatus'].setValue(
                7
              );
              this.settingsForm.controls[
                'preincubationcohortImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            case 11:
              this.settingsForm.controls['placementdriveStatus'].setValue(7);
              this.settingsForm.controls['placementdriveImagefile'].setValue(
                this.selecetdFile.name
              );
              break;
          }
        };
        // Add a timeout to show the uploading status
        setTimeout(function () {
          let datass = '.upload-wrapper' + val;
          $(datass).addClass('uploaded');
        }, 600);
        // Add a timeout to show the uploading status
        setTimeout(function () {
          let datas = '.upload-wrapper' + val;
          $(datas).removeClass('uploaded');
          $(datas).addClass('success');
          $(set).addClass('success');
        }, 1600);
        // Add a timeout to hide the upload button and show the remove button
        setTimeout(function () {
          let datas = '.upload-wrapper' + val;
          $(datas).addClass('d-none');
          $(datas).removeClass('success');
          let data = '.remove-wrapper' + val;
          $(data).addClass('d-flex');
          $(data).addClass('active');
        }, 5000);
      } else {
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png formet images are allowed'
        );
      }
    }
  }
  /**
   * Removes the uploaded file from the UI and resets the related form controls.
   *
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference used for accessing the form control.
   */
  removeFile(val: string, i: number, set: string) {
    // Reset the document values for the given index
    this.documentValues[i][0].documentFile = '';
    this.documentValues[i][0].documentName = '';

    // Timeout to animate the UI change
    setTimeout(() => {
      // Remove the 'd-none' class from the file input element
      const datass = `.upload-wrapper${val}`;
      $(datass).removeClass('d-none');

      // Remove the 'active' class from the remove file button
      const data = `.remove-wrapper${val}`;
      $(data).removeClass('d-flex');
      $(data).removeClass('active');

      // Remove the 'success' class from the form control
      $(set).removeClass('success');
    }, 1000);

    // Reset the related form control values
    switch (i) {
      case 0:
        this.settingsForm.controls['mentorNetworkImagefile'].setValue('');
        break;
      case 1:
        this.settingsForm.controls['expertiseAssistanceImagefile'].setValue('');
        break;
      case 2:
        this.settingsForm.controls['guidanceRegistrationImagefile'].setValue(
          ''
        );
        break;
      case 3:
        this.settingsForm.controls['filedGrantedImagefile'].setValue('');
        break;
      case 4:
        this.settingsForm.controls['dpiitregistrationImagefile'].setValue('');
        break;
      case 5:
        this.settingsForm.controls[
          'dpiitregistrationstartupsImagefile'
        ].setValue('');
        break;
      case 6:
        this.settingsForm.controls['totalPhysicalImagefile'].setValue('');
        break;
      case 7:
        this.settingsForm.controls['trainingworkshopImagefile'].setValue('');
        break;
      case 8:
        this.settingsForm.controls['newlettersImagefile'].setValue('');
        break;
      case 9:
        this.settingsForm.controls['mentorinvestorImagefile'].setValue('');
        break;
      case 10:
        this.settingsForm.controls['preincubationcohortImagefile'].setValue('');
        break;
      case 11:
        this.settingsForm.controls['placementdriveImagefile'].setValue('');
        break;
    }
  }
  Optionsonechecked = '';
  /**
   * Handles the change event of the 'Mentor Network' option.
   * Updates form controls and their validators based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference used for accessing the form control.
   */
  showOptionsone(event, val, i, set) {
    this.Optionsonechecked = event;
    if (event === 'No') {
      // If 'No' is selected, remove the file and clear validators
      this.removeFile(val, i, set);
      // Set the status to 1 (No) and clear the form controls
      this.settingsForm.controls['mentorNetworkStatus'].setValue(1);
      this.settingsForm.controls['mentorNetworkMentoringHours'].setValue(null);
      this.settingsForm.controls['mentorNetworkNoOfMentors'].setValue(null);
      this.settingsForm.controls['mentorNetworkImagefile'].setValue('');
      // Clear validators for the form controls
      this.settingsForm.controls[
        'mentorNetworkMentoringHours'
      ].clearValidators();
      this.settingsForm.controls['mentorNetworkNoOfMentors'].clearValidators();
      this.settingsForm.controls['mentorNetworkImagefile'].clearValidators();
    } else {
      // If 'Yes' is selected, add validators to the form controls
      this.settingsForm.controls['mentorNetworkMentoringHours'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['mentorNetworkNoOfMentors'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['mentorNetworkImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // Update the form controls with the new validators
    this.settingsForm.controls[
      'mentorNetworkMentoringHours'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'mentorNetworkNoOfMentors'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'mentorNetworkImagefile'
    ].updateValueAndValidity();
  }
  Optionstwochecked = '';
  /**
   * Handles the change event of the 'Expertise Assistance' option.
   * Updates form controls and their validators based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference used for accessing the form control.
   */
  showOptionstwo(event, val, i, set) {
    this.Optionstwochecked = event;
    if (event == 'No') {
      // If 'No' is selected, remove the file and clear validators
      this.removeFile(val, i, set);
      // Set the status to 1 (No) and clear the form controls
      this.settingsForm.controls['expertiseAssistanceStatus'].setValue(1);
      this.settingsForm.controls['expertiseAssistanceImagefile'].setValue('');
      this.settingsForm.controls[
        'expertiseAssistanceImagefile'
      ].clearValidators();
      // Clear the number of programs and set the validators
      this.settingsForm.controls['expertiseAssistanceNoOfProgrammes'].setValue(
        null
      );
      this.settingsForm.controls[
        'expertiseAssistanceNoOfProgrammes'
      ].clearValidators();
    } else {
      // If 'Yes' is selected, set the required validators
      this.settingsForm.controls[
        'expertiseAssistanceNoOfProgrammes'
      ].setValidators([Validators.required]);
      this.settingsForm.controls['expertiseAssistanceImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // Update the validity of the form controls
    this.settingsForm.controls[
      'expertiseAssistanceNoOfProgrammes'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'expertiseAssistanceImagefile'
    ].updateValueAndValidity();
  }
  Optionsthreechecked = '';
  /**
   * Handles the change event for the 'Guidance Registration' option.
   * Updates form controls based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference used for accessing the form control.
   */
  showOptionsthree(event, val, i, set) {
    // Store the selected option
    this.Optionsthreechecked = event;

    if (event == 'No') {
      // If 'No' is selected, remove the associated file and clear validators
      this.removeFile(val, i, set);
      // Update the status to 'No'
      this.settingsForm.controls['guidanceRegistrationStatus'].setValue(1);
      // Clear the URL and image fields
      this.settingsForm.controls['guidanceRegistrationUrlIcWebsite'].setValue(
        ''
      );
      this.settingsForm.controls['guidanceRegistrationImagefile'].setValue('');
      // Clear validators for the URL and image fields
      this.settingsForm.controls[
        'guidanceRegistrationUrlIcWebsite'
      ].clearValidators();
      this.settingsForm.controls[
        'guidanceRegistrationImagefile'
      ].clearValidators();
    } else {
      // If 'Yes' is selected, set required validators for the fields
      // Set validators for the URL field
      this.settingsForm.controls[
        'guidanceRegistrationUrlIcWebsite'
      ].setValidators([Validators.required, RxwebValidators.url()]);
      // Set validators for the image field
      this.settingsForm.controls['guidanceRegistrationImagefile'].setValidators(
        [Validators.required]
      );
    }
    // Update the validity of the form controls
    this.settingsForm.controls[
      'guidanceRegistrationUrlIcWebsite'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'guidanceRegistrationImagefile'
    ].updateValueAndValidity();
  }
  Optionsfourchecked = '';
  /**
   * Handles the change event for the 'Filed Granted' option.
   * Updates form controls based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference used for accessing the form control.
   */
  showOptionsfour(event, val, i, set) {
    // Store the selected option
    this.Optionsfourchecked = event;

    if (event == 'No') {
      // If 'No' is selected, remove the associated file and clear validators
      this.removeFile(val, i, set);
      this.settingsForm.controls['filedGrantedStatus'].setValue(1);
      this.settingsForm.controls['filedGrantedNoOfIPFiled'].setValue(null);
      this.settingsForm.controls['filedGrantedNoOfIPFiled'].clearValidators();
      this.settingsForm.controls['filedGrantedImagefile'].setValue('');
      this.settingsForm.controls['filedGrantedImagefile'].clearValidators();
    } else {
      // If 'Yes' is selected, set required validators for the fields
      this.settingsForm.controls['filedGrantedNoOfIPFiled'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['filedGrantedImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // Update the validity of the form controls
    this.settingsForm.controls[
      'filedGrantedNoOfIPFiled'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'filedGrantedImagefile'
    ].updateValueAndValidity();
  }
  Optionsfivechecked = '';
  /**
   * Handles the change event for the 'Number of Startups Recognized under DPIIT'
   * radio button options.
   * Updates the form controls and their validators based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference used for accessing the form control
   */
  showOptionsfive(event, val, i, set) {
    this.Optionsfivechecked = event;

    // Clear the values and validators if the user selects 'No'
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['dpiitregistrationStatus'].setValue(1);
      this.settingsForm.controls['dpiitregistrationNoOfProgrammes'].setValue(
        null
      );
      this.settingsForm.controls[
        'dpiitregistrationNoOfProgrammes'
      ].clearValidators();
      this.settingsForm.controls['dpiitregistrationImagefile'].setValue('');
      this.settingsForm.controls[
        'dpiitregistrationImagefile'
      ].clearValidators();
    }
    // Set required validators if the user selects 'Yes'
    else {
      this.settingsForm.controls[
        'dpiitregistrationNoOfProgrammes'
      ].setValidators([Validators.required]);
      this.settingsForm.controls['dpiitregistrationImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // Update the validity of the form controls
    this.settingsForm.controls[
      'dpiitregistrationNoOfProgrammes'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'dpiitregistrationImagefile'
    ].updateValueAndValidity();
  }
  Optionssixchecked = '';
  /**
   * Handles the change event for the 'Number of Startups Recognized under DPIIT'
   * radio button options.
   * Updates the form controls and their validators based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference used for accessing the form control
   */
  showOptionssix(event, val, i, set) {
    this.Optionssixchecked = event;
    if (event == 'No') {
      this.removeFile(val, i, set);
      // Clear the values and validators if the user selects 'No'
      this.settingsForm.controls['dpiitregistrationstartupsStatus'].setValue(1);
      this.settingsForm.controls['dpiitregistrationstartupsImagefile'].setValue(
        ''
      );
      this.settingsForm.controls[
        'dpiitregistrationstartupsImagefile'
      ].clearValidators();
      this.settingsForm.controls['incubateesdpiitrecogcount'].setValue('');
      this.settingsForm.controls['incubateesdpiitrecogcount'].clearValidators();
    } else {
      // Set required validators if the user selects 'Yes'
      this.settingsForm.controls['incubateesdpiitrecogcount'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls[
        'dpiitregistrationstartupsImagefile'
      ].setValidators([Validators.required]);
    }
    // Update the validity of the form controls
    this.settingsForm.controls[
      'incubateesdpiitrecogcount'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'dpiitregistrationstartupsImagefile'
    ].updateValueAndValidity();
  }

  Optionssevenchecked = '';
  /**
   * Handles the change event for the 'Total Physical Incubation Space'
   * radio button options.
   * Updates the form controls and their validators based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference used for additional UI updates.
   */
  showOptionsseven(event, val, i, set) {
    // Store the selected option in Optionssevenchecked
    this.Optionssevenchecked = event;

    if (event === 'No') {
      // If 'No' is selected, remove the file and clear validators
      this.removeFile(val, i, set);
      // Set the value of totalPhysicalStatus to 1 and clear validators for
      // totalPhysicalImagefile, noofVirtual, and noofPhysical
      this.settingsForm.controls['totalPhysicalStatus'].setValue(1);
      this.settingsForm.controls['totalPhysicalImagefile'].setValue('');
      this.settingsForm.controls['totalPhysicalImagefile'].clearValidators();
      this.settingsForm.controls['noofVirtual'].setValue(null);
      this.settingsForm.controls['noofVirtual'].clearValidators();
      this.settingsForm.controls['noofPhysical'].setValue(null);
      this.settingsForm.controls['noofPhysical'].clearValidators();
    } else {
      // If 'Yes' is selected, set required validators for totalPhysicalImagefile,
      // noofVirtual, and noofPhysical
      this.settingsForm.controls['totalPhysicalImagefile'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['noofVirtual'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['noofPhysical'].setValidators([
        Validators.required,
      ]);
    }
    // Update the validity of the form controls
    this.settingsForm.controls[
      'totalPhysicalImagefile'
    ].updateValueAndValidity();
    this.settingsForm.controls['noofVirtual'].updateValueAndValidity();
    this.settingsForm.controls['noofPhysical'].updateValueAndValidity();
  }
  Options8checked = '';
  /**
   * Handles the change event for the training workshop options.
   * Updates the form controls and their validators based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference used for additional UI updates.
   */
  showOptions8(event, val, i, set) {
    // Store the selected option in Options8checked
    this.Options8checked = event;

    if (event === 'No') {
      // If 'No' is selected, remove the file and clear validators
      this.removeFile(val, i, set);
      this.settingsForm.controls['trainingworkshopStatus'].setValue(1);
      this.settingsForm.controls['trainingworkshopNoofprograms'].setValue('');
      this.settingsForm.controls['trainingworkshopImagefile'].setValue('');
      // Clear the validators for the number of programs and image file fields
      this.settingsForm.controls[
        'trainingworkshopNoofprograms'
      ].clearValidators();
      this.settingsForm.controls['trainingworkshopImagefile'].clearValidators();
    } else {
      // If 'Yes' is selected, set the required validators
      this.settingsForm.controls['trainingworkshopNoofprograms'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['trainingworkshopImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // Update the validity of the number of programs and image file fields
    this.settingsForm.controls[
      'trainingworkshopNoofprograms'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'trainingworkshopImagefile'
    ].updateValueAndValidity();
  }
  Options9checked = '';
  /**
   * Handles the change event for the newsletters options.
   * Updates the form controls and their validators based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference used for additional UI updates.
   */
  showOptions9(event, val, i, set) {
    this.Options9checked = event;

    if (event == 'No') {
      // If 'No' is selected, remove the file and clear validators
      this.removeFile(val, i, set);
      this.settingsForm.controls['newlettersStatus'].setValue(1);
      this.settingsForm.controls['newlettersUrlIcWebsite'].setValue('');
      this.settingsForm.controls['newlettersImagefile'].setValue('');
      // Clear the validators for the URL and image file fields
      this.settingsForm.controls['newlettersUrlIcWebsite'].clearValidators();
      this.settingsForm.controls['newlettersImagefile'].clearValidators();
    } else {
      // If 'Yes' is selected, set the validators for the URL and image file fields
      this.settingsForm.controls['newlettersUrlIcWebsite'].setValidators([
        Validators.required,
        RxwebValidators.url(),
      ]);
      this.settingsForm.controls['newlettersImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // Update the validity of the URL and image file fields
    this.settingsForm.controls[
      'newlettersUrlIcWebsite'
    ].updateValueAndValidity();
    this.settingsForm.controls['newlettersImagefile'].updateValueAndValidity();
  }
  Options10checked = '';
  /**
   * Handles the change event for the mentor investors options.
   * Updates the form controls and their validators based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference used for additional UI updates.
   */
  showOptions10(event, val, i, set) {
    this.Options10checked = event;
    if (event == 'No') {
      // If 'No' is selected, remove the file and clear validators
      this.removeFile(val, i, set);
      this.settingsForm.controls['mentorinvestorStatus'].setValue(1);
      this.settingsForm.controls['mentorinvestorNoofprograms'].setValue(null);
      // Clear the validators for the no of programs field
      this.settingsForm.controls[
        'mentorinvestorNoofprograms'
      ].clearValidators();
      this.settingsForm.controls['mentorinvestorImagefile'].setValue('');
      // Clear the validators for the image file field
      this.settingsForm.controls['mentorinvestorImagefile'].clearValidators();
    } else {
      // If 'Yes' is selected, set the validators for the no of programs and image file fields
      this.settingsForm.controls['mentorinvestorNoofprograms'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['mentorinvestorImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // Update the validity of the no of programs and image file fields
    this.settingsForm.controls[
      'mentorinvestorNoofprograms'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'mentorinvestorImagefile'
    ].updateValueAndValidity();
  }
  Options11checked = '';
  /**
   * Handles the change event for the preincubation cohort options.
   * Updates the form controls and their validators based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference used for additional UI updates.
   */
  showOptions11(event, val, i, set) {
    // Store the selected option in Options11checked
    this.Options11checked = event;

    if (event == 'No') {
      // If 'No' is selected, remove the file and clear validators
      this.removeFile(val, i, set);
      this.settingsForm.controls['preincubationcohortStatus'].setValue(1);
      this.settingsForm.controls['preincubationcohortNoofprograms'].setValue(
        null
      );
      this.settingsForm.controls[
        'preincubationcohortNoofprograms'
      ].clearValidators();
      this.settingsForm.controls['preincubationcohortImagefile'].setValue('');
      this.settingsForm.controls[
        'preincubationcohortImagefile'
      ].clearValidators();
    } else {
      // If 'Yes' is selected, set the required validators
      this.settingsForm.controls[
        'preincubationcohortNoofprograms'
      ].setValidators([Validators.required]);
      this.settingsForm.controls['preincubationcohortImagefile'].setValidators([
        Validators.required,
      ]);
    }

    // Update the validity of the form controls
    this.settingsForm.controls[
      'preincubationcohortNoofprograms'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'preincubationcohortImagefile'
    ].updateValueAndValidity();
  }
  Options12checked = '';
  /**
   * Handles the change event for the placement drive options.
   * Updates the form controls and their validators based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference used for additional UI updates.
   */
  showOptions12(event, val, i, set) {
    // Store the selected option in Options12checked
    this.Options12checked = event;

    if (event == 'No') {
      // If 'No' is selected, remove the file and clear validators
      this.removeFile(val, i, set);
      this.settingsForm.controls['placementdriveStatus'].setValue(1);
      this.settingsForm.controls['placementdriveNoofdrives'].setValue(null);
      this.settingsForm.controls['placementdriveNoofdrives'].clearValidators();
      this.settingsForm.controls['placementdriveImagefile'].setValue('');
      this.settingsForm.controls['placementdriveImagefile'].clearValidators();
    } else {
      // If 'Yes' is selected, set the required validators
      this.settingsForm.controls['placementdriveNoofdrives'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['placementdriveImagefile'].setValidators([
        Validators.required,
      ]);
    }

    // Update the validity of the form controls
    this.settingsForm.controls[
      'placementdriveNoofdrives'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'placementdriveImagefile'
    ].updateValueAndValidity();
  }
  /**
   * Saves the form data to the API.
   * If the form is invalid, shows an error notification.
   * If the form is valid, attaches document values if available, and submits the data to the API.
   * Shows notifications based on the result.
   */
  saveBtn() {
    let getform = this.settingsForm.value;

    if (this.settingsForm.invalid) {
      // Mark all form fields as touched and show an error notification if the form is invalid
      this.settingsForm.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      // Attach documents to the form data if available
      if (this.documentValues[0][0].documentFile != '') {
        getform.mentorNetworkDocuments = this.documentValues[0];
      }
      if (this.documentValues[1][0].documentFile != '') {
        getform.expertiseAssistanceDocuments = this.documentValues[1];
      }
      if (this.documentValues[2][0].documentFile != '') {
        getform.guidanceRegistrationDocuments = this.documentValues[2];
      }
      if (this.documentValues[3][0].documentFile != '') {
        getform.filedGrantedDocuments = this.documentValues[3];
      }
      if (this.documentValues[4][0].documentFile != '') {
        getform.dpiitregistrationDocuments = this.documentValues[4];
      }
      if (this.documentValues[5][0].documentFile != '') {
        getform.dpiitregistrationstartupsDocuments = this.documentValues[5];
      }
      if (this.documentValues[6][0].documentFile != '') {
        getform.totalPhysicalDocuments = this.documentValues[6];
      }
      if (this.documentValues[7][0].documentFile != '') {
        getform.trainingworkshopDocuments = this.documentValues[7];
      }
      if (this.documentValues[8][0].documentFile != '') {
        getform.newlettersDocuments = this.documentValues[8];
      }
      if (this.documentValues[9][0].documentFile != '') {
        getform.mentorinvestorDocuments = this.documentValues[9];
      }
      if (this.documentValues[10][0].documentFile != '') {
        getform.preincubationcohortDocuments = this.documentValues[10];
      }
      if (this.documentValues[11][0].documentFile != '') {
        getform.placementdriveDocuments = this.documentValues[11];
      }

      // Show loading indicator
      this.getdata.amizhthLoader('show');

      // Send form data to the API
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        // Hide loading indicator
        this.getdata.amizhthLoader('hide');
        // Check API response status
        if (data.responseStatus == 'Success') {
          // Increment the step value if the API call is successful
          this.step++;
          // Show success notification
          this.notify.notifysuccess(data.responseMessage);
          // Call the getDataApi method to fetch the data again
          this.getDataApi();
        } else {
          // Show error notification
          this.notify.notifyError(data.responseMessage);
        }
      });
    }
  }
  guidelinesBtn(data) {
    this.appCom.guidelinesModal(data);
  }
  guidelineValue: any = [];
  guidelineDatas() {
    this.http.get('/assets/json/guideline.json').subscribe((data) => {
      this.guidelineValue = data[1].questions;
    });
  }
  step = 0;
  setStep(index: number) {
    this.step = index;
  }
  nextStep() {
    this.saveBtn();
  }
  prevStep() {
    this.step--;
  }
}
